<!-- 申请公证结果页面 -->
<template>
    <div class="result-container text-center">
      <img class="state-img" :src="img1" />
      <div class="rem32 mt15">
        <span>{{ reasonTxt }}</span>
      </div>
      <div class="result-btn">
        <van-button round block color="#4D7BFE" class="btn" @click="toIndex">
          <span class="rem34">返回首页</span>
        </van-button>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import Vue from 'vue'
  import { Button } from 'vant'
  import { dealerDetailApi } from '@/apis/kdb';
  
  Vue.use(Button)
  export default {
    data() {
      return {
        img1: require('@/assets/images/kdb/confirmed.png'),
        reasonTxt: '公证中',
        productInfo: {
          lcAppl: {
            inSts: 0
          }
        }
      }
    },
    created() {
      this.dealerDetailFun()
    },
    computed: {
      ...mapState({
        loanNo: (state) => state.borrow.loanNo,
        faceToken: (state) => state.borrow.faceToken,
        productCode: (state) => state.common.productCode,
        applySeq: (state) => state.borrow.applySeq,
      }),
    },
    methods: {
        async dealerDetailFun(){
          try {
              let id = this.$store.state.common.id || localStorage.getItem('id')
              
              let res = await dealerDetailApi({id}) 
              if (res && res.code == 200) {
                  this.productInfo = res.data
                  if(this.productInfo.lcAppl.inSts === 131) {
                    this.reasonTxt = '公证失败'
                  }else if(this.productInfo.lcAppl.inSts === 140){
                    // 去首付款
                    this.$router.push({
                      path: '/downPayment',
                      query: {
                        amount: Number(this.productInfo.downPayment)
                      }
                    })
                  }
              } else {
                  this.$common.toast(res.msg)
              }
          } catch (error) {}
      },
      toIndex() {
        this.$router.push({ path: this.$store.state.common.defaultIndex })
      },
    },
  }
  </script>
  
  <style lang="less" scoped>
  .result-container {
    padding: 0 0.42rem /* 21/50 */;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    .state-img {
      margin-top: 1rem;
      width: 5rem;
    }
    .result-btn {
      position: absolute;
      margin-top: 0.82rem /* 41/50 */;
      bottom: 2.3rem;
      width: calc(100% - 0.84rem);
    }
    .btn {
      margin-top: 0.48rem /* 24/50 */;
    }
  }
  </style>
  
  